module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.use),
      expression: "use"
    }],
    ref: "toast",
    class: _vm.$style.toast,
    style: ({
      top: _vm.top,
      left: _vm.left
    })
  }, [(_vm.type.default) ? _c('div', [_vm._v(_vm._s(this.info))]) : (_vm.type.success) ? _c('div', [_vm._m(0), _vm._v(_vm._s(this.info))]) : (_vm.type.error) ? _c('div', [_vm._m(1), _vm._v(_vm._s(this.info))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/img/common/success.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/img/common/error.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b92dde5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/toast.vue
// module id = 237
// module chunks = 45